import AscUnauthorizedContainer from './containers/AscUnauthorizedContainer'

const unauthorizedRouter = {
  icon: 'mdi-home',
  path: '/logout/unauthorized',
  name: 'Unauthorized',
  display: true,
  component: AscUnauthorizedContainer,
  children: [],
  meta: {
    fullscreen: true,
    breadcrumbs: [],
  },
}

export default unauthorizedRouter
